<template>

    <div class="row">
        <div class="form-group">
            <label>
                <input v-model="props.data.checkboxLease" type="checkbox" name="FounderFLIsBeneficiary"
                    :disabled="disabled">
                <span>Имеется действующие договоры с другими лизинговыми компаниями</span>
            </label>
        </div>

    </div>

    <div v-if="props.data.checkboxLease" v-for="(item, index) in Lease" :key="index" class="mt-3">

        <div class="row">
            <div class="col-md-8 col-lg-6">

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'company')">
                    <ui-input v-model="item.company" type="text" placeholder="Лизинговая компания"
                        :disabled="disabled" />
                    <ui-input-label>Лизинговая компания</ui-input-label>
                </ui-input-box-floating> -->


                <Autocomplete class="mb-3" v-model="item.company" type="party" label="Лизинговая компания"
                    placeholder="Лизинговая компания" :error="getError(index, 'company')" :disabled="disabled" @select="(d) => {
                        item.company = d.value || ''
                    }" />

                <div class="row">

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'maxDate')">
                            <ui-input v-model="item.maxDate" type="date" placeholder="Максимальная дата окончания"
                                :disabled="disabled" />
                            <ui-input-label>Максимальная дата окончания</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'qty')">
                            <ui-input v-model="item.qty" type="text" placeholder="Количество договоров"
                                :disabled="disabled" />
                            <ui-input-label>Количество договоров</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'total')">
                            <ui-input v-model="item.total" type="text" placeholder="Общая сумма договоров"
                                :disabled="disabled" />
                            <ui-input-label>Общая сумма договоров</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'debt')">
                            <ui-input v-model="item.debt" type="text" placeholder="Остаток задолженности по договорам"
                                :disabled="disabled" />
                            <ui-input-label>Остаток задолженности по договорам</ui-input-label>
                        </ui-input-box-floating>

                    </div>



                </div>

            </div>

        </div>

        <button @click="() => del(index)" class="btn btn-ghost btn-small mb-2"
            :disabled="Lease.length == 1 || disabled">Удалить сведения</button>
    </div>

    <button v-if="props.data.checkboxLease" @click="add" class="btn btn-base btn-small" :disabled="disabled">Добавить
        сведения</button>
</template>

<script setup>

import { ref, onMounted, watch } from 'vue'

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    errors: {
        type: Object,
        default: {}
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const Lease = ref([])

const add = () => {
    Lease.value = [...Lease.value, {}]
}

const del = (index) => {
    Lease.value = Lease.value.filter((item, itemIndex) => itemIndex !== index)
}

const getError = (index, field) =>
    props.errors?.Lease?.[index]?.[field] || false

onMounted(async () => {

    const isValidObjectArray = Array.isArray(props.data?.Lease) && props.data.Lease.every(item => typeof item === 'object' && !Array.isArray(item))

    Lease.value = isValidObjectArray ? props.data.Lease : [{}]


})

watch(Lease, (newValue) => {

    props.data.Lease = newValue

}, { deep: true })


watch(() => props.data.checkboxLease, (newVal) => {
    if (newVal) {
        Lease.value = [
            {}
        ];
    }
});

</script>